import { Component, OnInit } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ListeableComponent } from '../../../../shared/components/interfaces/listeable.component';
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { AuthService } from '../../../security/service/auth.service';
import { IssueFilterModel } from '../../model/issue-filter.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueService } from '../../service/issue.service';
import moment = require('moment');

type CustomerModel = {
  id: number;
  value: string;
};

type SitesModel = {
  id: string;
  value: string;
  number: string;
};

@Component({
  selector: 'issue-list',
  templateUrl:
    'console/app-js/modules/issue/components/list/issue-list.component.html'
})
export class IssueListComponent extends APIOperableComponent
  implements ListeableComponent, OnInit {
  protected gridData: any = [];
  protected issueFilterModel = new IssueFilterModel();
  protected loading: Boolean = false;

  protected customerData: Array<CustomerModel> = [];
  protected customerDataOriginal: Array<CustomerModel>;
  protected siteData: Array<SitesModel> = [];
  protected isSiteDisabled = true;
  // Modal props
  protected selectedCustomer: CustomerModel;
  protected selectedSite: SitesModel;
  noRecordsSettings;

  constructor(
    protected progressService: NgProgress,
    protected toastr: ToastrService,
    protected authService: AuthService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
    this.setDefaultNoRecordSettings();
  }

  public issueColumns = [
    {
      label: 'Customer',
      cellClass: 'hover',
      template: {
        type: 'content',
        property: 'customerNumbers'
      },
      width: 20,
      type: 'html'
    },
    {
      label: 'Issue',
      cellClass: 'hover',
      template: {
        type: 'content',
        property: 'name'
      },
      width: 30,
      type: 'html'
    },
    {
      label: 'LOS/SD',
      property: 'lineOfServiceShortDescription',
      type: 'string',
      editable: false,
      cellClass: 'los-cell',
      isVisible: true,
      width: '20'
    },
    {
      label: 'Keywords',
      cellClass: 'hover',
      template: {
        type: 'content',
        property: 'keywords'
      },
      isVisible: true,
      width: 20,
      type: 'html'
    },
    {
      label: 'Cust Msgs',
      cellClass: 'hoverAlways',
      template: {
        type: 'content',
        property: 'hasMessages'
      },
      type: 'html',
      property: 'hasMessages',
      isVisible: false,
      width: '20'
    },
    {
      label: 'Site Msgs',
      cellClass: 'hoverAlways',
      template: {
        type: 'content',
        property: 'hasSiteMessages'
      },
      type: 'html',
      property: 'hasSiteMessages',
      isVisible: false,
      width: '20'
    },
    {
      label: 'Questions',
      cellClass: 'hoverAlways',
      template: {
        type: 'content',
        property: 'hasQuestions'
      },
      isVisible: true,
      width: 20,
      type: 'html'
    },
    {
      label: 'Self Help',
      cellClass: 'hover',
      template: {
        type: 'content',
        property: 'hasSelfHelp'
      },
      editable: false,
      isVisible: true,
      width: '20',
      type: 'html'
    },
    {
      label: 'Site Specific Messages',
      cellClass: 'hoverAlways',
      template: {
        type: 'content',
        property: 'hasSiteSpecificMessages'
      },
      type: 'html',
      property: 'hasSiteSpecificMessages',
      isVisible: false,
      width: '20'
    },
    {
      label: 'Start Date',
      property: 'startDate',
      type: 'string',
      editable: false,
      cellClass: 'startDate-cell',
      isVisible: false,
      width: '20'
    },
    {
      label: 'End Date',
      property: 'endDate',
      type: 'string',
      editable: false,
      cellClass: 'endDate-cell',
      isVisible: false,
      width: '20'
    }
  ];

  ngOnInit() {
    this.loadCustomer();
    this.searchIssues();
    localStorage.removeItem('cNum');
  }

  /**
   *Get List of Customer
   */
  private loadCustomer(): void {
    this.issueService.getCustomer().subscribe(
      (res: any) => {
        if (res.responseCode === 200) {
          let results = res.results.map((cust, index) => {
            return {
              id: index,
              value: cust.number
            };
          });
          this.customerData = SortUtils.sortCollection(results, 'value');
          this.customerDataOriginal = this.customerData;
        } else {
          this.onAPIError(IssueUIMessages.LOAD_CUSTOMER_LIST_ERROR);
        }
      },
      () => this.onAPIError(IssueUIMessages.LOAD_CUSTOMER_LIST_ERROR)
    );
  }

  /**
   *Get List of Sites for a given customer.  Requires that a customer already be selected.
   */
  private loadSites(): void {
    if (this.selectedCustomer != null) {
      this.issueService
        .getAllSitesForCustomer(this.selectedCustomer.value)
        .subscribe(
          (res: any) => {
            if (res.responseCode === 200) {
              let results = res.results.map(site => {
                return {
                  id: site.id,
                  value: `${site.name} - ${site.city}/${site.state} - ${
                    site.number
                  }`,
                  number: site.number
                };
              });
              this.siteData = SortUtils.sortCollection(results, 'value');
              this.isSiteDisabled = false;
            } else {
              this.onAPIError(IssueUIMessages.LOAD_SITE_LIST_ERROR);
            }
          },
          () => this.onAPIError(IssueUIMessages.LOAD_SITE_LIST_ERROR)
        );
    }
  }

  /**
   * Filterchange For Customer
   * @param value
   */
  protected filterChangeCustomer(cust) {
    if (!cust && this.selectedCustomer) {
      this.selectedCustomer = undefined;
      localStorage.removeItem('cNum');
      this.issueFilterModel.customerNumber = undefined;
      this.updateGridfromSite(false);
      this.issueColumns.find(
        i => i.property === 'hasMessages'
      ).isVisible = false;
      this.issueColumns.find(
        i => i.property === 'hasSiteMessages'
      ).isVisible = false;
      this.searchIssues();
      this.clearSiteSelection();
      if (cust === '') {
        this.loadCustomer();
      }
    }
  }

  selectionChange(cust: CustomerModel) {
    if (cust) {
      localStorage.setItem('cNum', cust.value);
      this.selectedCustomer = cust;
      this.issueFilterModel.customerNumber = cust.value;
      this.issueColumns.find(
        i => i.property === 'hasMessages'
      ).isVisible = true;
      this.issueColumns.find(
        i => i.property === 'hasSiteMessages'
      ).isVisible = true;
      this.searchIssues();
      this.clearSiteSelection();
      this.loadSites();
    } else {
      this.issueFilterModel.customerNumber = undefined;
    }
  }

  /**
   * Filterchange For Site
   * @param value
   */
  protected filterChangeSite(site) {
    if (!site && this.selectedSite) {
      this.selectedSite = undefined;
      this.issueFilterModel.siteId = undefined;
      this.updateGridfromSite(false);
      this.searchIssues();
      if (site === '') {
        this.loadSites();
      }
    }
  }

  selectionChangeSite(site: SitesModel) {
    if (site) {
      this.selectedSite = site;
      this.issueFilterModel.siteId = site.id;
      this.issueFilterModel.siteNumber = site.number;
      this.searchIssues();
      this.updateGridfromSite(true);
    } else {
      this.selectedSite = null;
      this.issueFilterModel.siteId = undefined;
      this.issueFilterModel.siteNumber = undefined;
    }
  }
  protected clearSiteSelection(): void {
    this.selectedSite = undefined;
    this.issueFilterModel.siteId = undefined;
    this.issueFilterModel.siteNumber = undefined;
    this.isSiteDisabled = true;
  }

  updateGridfromSite(sites: boolean) {
    this.issueColumns.find(
      i => i.property === 'hasMessages'
    ).isVisible = !sites;
    this.issueColumns.find(i => i.label === 'Keywords').isVisible = !sites;
    this.issueColumns.find(i => i.label === 'Questions').isVisible = !sites;
    this.issueColumns.find(i => i.label === 'Self Help').isVisible = !sites;
    this.issueColumns.find(i => i.property === 'startDate').isVisible = sites;
    this.issueColumns.find(i => i.property === 'endDate').isVisible = sites;
    this.issueColumns.find(
      i => i.property === 'hasMessages'
    ).isVisible = !sites;
    this.issueColumns.find(
      i => i.property === 'hasSiteMessages'
    ).isVisible = !sites;
    this.issueColumns.find(
      i => i.property === 'hasSiteSpecificMessages'
    ).isVisible = sites;
  }

  /**
   *  Performs a search for an asset with the given parameters.
   */
  protected searchIssues(): void {
    this.progressRef.start(); // START PROGRESS
    this.gridData = [];
    this.loading = true;
    this.setDefaultNoRecordSettings();
    this.issueService.getIssues(this.issueFilterModel).subscribe(
      (res: any) => {
        // Issue response doesnt contain results may need to update in future
        if (res) {
          let results = res.map(issue => {
            return {
              id: issue.id,
              name: issue.name,
              lineOfService: issue.lineOfService,
              lineOfServiceShortDescription:
                issue.lineOfService + ' / ' + issue.shortDescription,
              lineOfServiceId: issue.lineOfServiceId,
              shortDescription: issue.shortDescription,
              customerNumbers: this.filterCustomerNumbers(
                issue.customerNumbers
              ),
              keywords: this.removeWhiteSpaceValueFromArray(issue.keywords),
              hasMessages: issue.hasMessages ? 'Yes' : 'No',
              hasSiteMessages: issue.hasSiteMessages ? 'Yes' : 'No',
              hasSiteSpecificMessages: issue.hasSiteMessages ? 'Yes' : 'No',
              hasQuestions: issue.hasQuestions ? 'Yes' : 'No',
              hasSelfHelp: issue.hasSelfHelp ? 'Yes' : 'No',
              siteId: this.getSiteId(),
              siteNumber: this.getSiteNumber(),
              startDate:
                issue.startDate !== undefined
                  ? moment(new Date(issue.startDate)).format('MM/DD/YYYY')
                  : 'Not Set',
              endDate:
                issue.endDate !== undefined
                  ? moment(new Date(issue.endDate)).format('MM/DD/YYYY')
                  : 'Not Set'
            };
          });

          if (results.length === 0) {
            this.noRecordsSettings.message = 'No results found';
            this.noRecordsSettings.styleClass = null;
          }
          this.gridData = results;
          this.progressRef.complete();
        } else {
          this.onAPIError(IssueUIMessages.LOAD_ISSUE_ERROR);
        }
        this.loading = false;
      },
      () => {
        this.onAPIError(IssueUIMessages.LOAD_ISSUE_ERROR);
        this.loading = false;
      }
    );
  }

  private getSiteId() {
    if (this.issueFilterModel.siteId !== undefined) {
      return this.issueFilterModel.siteId;
    } else {
      return null;
    }
  }

  private getSiteNumber() {
    if (this.issueFilterModel.siteNumber !== undefined) {
      return this.issueFilterModel.siteNumber;
    } else {
      return null;
    }
  }

  private filterCustomerNumbers(customerArray) {
    if (this.issueFilterModel.customerNumber != undefined) {
      let customerFilteredArray = customerArray.filter(customerNo => {
        if (customerNo === this.issueFilterModel.customerNumber) {
          return customerNo;
        }
      });
      if (customerFilteredArray.length > 0) {
        return customerFilteredArray;
      }
    }
    return customerArray;
  }

  private removeWhiteSpaceValueFromArray(array) {
    if (array !== undefined) {
      let newArray;
      newArray = array.filter(e => {
        return e !== '';
      });
      if (newArray.length > 0) {
        return newArray;
      } else {
        return 'Not Set';
      }
    }
    return 'Not Set';
  }

  /**
   * Set No Records Settings to Default state.
   */
  private setDefaultNoRecordSettings(): void {
    this.noRecordsSettings = {
      message: '',
      styleClass: 'no-records-wrapper'
    };
  }

  protected onQuickSearch(event): void {
    this.issueFilterModel.quickSearch = event.currentTarget.value;
    if (
      event.currentTarget.value.length > 2 ||
      event.currentTarget.value.length === 0
    ) {
      this.searchIssues();
    }
  }

  /**
   * Does not let user input special characters
   * @param e character the user keypresses
   */
  protected checkSpecialChar(e): any {
    if (
      (e.which < 48 &&
        e.which !== 45 &&
        e.which !== 39 &&
        e.which !== 38 &&
        e.which !== 32) ||
      (e.which > 57 && e.which < 65 && e.which !== 64) ||
      (e.which > 90 && e.which < 97) ||
      e.which > 122
    ) {
      e.preventDefault();
      return true;
    }
  }

  onReset(): void {
    // Not yet implemented on this module.
  }

  onSearch(): void {
    // Not yet implemented on this module.
  }

  onDeleteItems(): void {
    // Not yet implemented on this module.
  }
  onAddItem(): void {
    // Not yet implemented on this module.
  }
  onFullscreenMode(): void {
    // Not yet implemented on this module.
  }
  reload(eve) {
    if (eve) {
      setTimeout(() => {
        this.searchIssues();
      }, 500);
    }
  }
}
